import ReactDOM from "react-dom/client";
import { Provider } from "./components/ui/provider";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { Flex } from "@chakra-ui/react";
import Home from "./pages/home";
import Header from "./components/header";
import Terms from "./pages/terms";
import Privacy from "./pages/privacy";

const root = document.getElementById("root");
const dom = ReactDOM.createRoot(root);

dom.render(
	<Provider>
		<BrowserRouter>
			<Flex direction="column" minH="100vh" gap={4}>
				<Header />
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/terms" element={<Terms />} />
					<Route path="/privacy" element={<Privacy />} />
					<Route path="*" element={<Navigate to={"/"} replace />} />
				</Routes>
			</Flex>
		</BrowserRouter>
	</Provider>,
);
